import { Observable, catchError, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ManifestService {

  private _jsonURL =  'https://' + window.location.host + '/manifest.json';

  constructor(private http: HttpClient) {}

   /**
   * Get manifest data
   * @returns Observable with manifest data
   */
    public getManifestData(): Observable<any> {
      return this.http.get(this._jsonURL).pipe(
        catchError((error) => {
          return of(false);
        })
      );
    }
}
